import { render, staticRenderFns } from "./FeaturesCarousel.vue?vue&type=template&id=50849bcd&scoped=true&"
import script from "./FeaturesCarousel.vue?vue&type=script&lang=js&"
export * from "./FeaturesCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50849bcd",
  null
  
)

export default component.exports